// extracted by mini-css-extract-plugin
module.exports = {"form":"_5D3aRVZ1","text-field":"_5DX1IX3L","submit-btn":"_5D302pnN","loader":"_5D3CQj1Z"};